import { render, staticRenderFns } from "./MentoringTrainingCataloguesData.vue?vue&type=template&id=0bf456bd&scoped=true"
import script from "./MentoringTrainingCataloguesData.vue?vue&type=script&lang=js"
export * from "./MentoringTrainingCataloguesData.vue?vue&type=script&lang=js"
import style0 from "./MentoringTrainingCataloguesData.vue?vue&type=style&index=0&id=0bf456bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf456bd",
  null
  
)

export default component.exports